import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { Divider } from 'antd';
import Tag from '../../../components/common/Tag';
import { convertToHoursAndMinutes, Description } from '../../../utils/common_functions';
import { reportingDonePoints, ReportingType } from '../../../utils/constant';
import { FlexWrapper, PurpleText } from '../../../theme/common_style';
import ExpandCollapseWrapper from '../../../components/common/ExpandCollapseWrapper';
import { useTheme } from '@emotion/react';
import dayjs from 'dayjs';

const ReportingCard = ({ report, empName }) => {
  const theme = useTheme();
  const billingTime = report?.billable ? convertToHoursAndMinutes(report?.billable_mins) : null;

  return (
    <ExpandCollapseWrapper
      title={
        <div className="title-name">
          {empName || report?.project?.name}{' '}
          {report?.reporting_type === ReportingType.MANUAL && <PurpleText>(Manual)</PurpleText>}
        </div>
      }
      content={
        report?.billable &&
        report?.billable_mins && (
          <Tag.primary
            style={{
              padding: '2px 8px',
              fontSize: '13px',
              fontWeight: '600',
              borderRadius: '10px'
            }}>
            Billing: {billingTime?.hours} Hrs {billingTime?.minutes} Mins
          </Tag.primary>
        )
      }
      reportingTime={
        <PurpleText size={'13px'}>
          {dayjs(report?.created_at).format('DD MMM, YYYY hh:mm A')}
        </PurpleText>
      }
      defaultExpanded={false}>
      <ContentWrapper>
        <FlexWrapper direction="column" align="start" width="100%" justify="start" cursor="default">
          <Divider style={{ borderColor: '#F1F1F1', margin: '0', borderWidth: '1.5px' }} />
          <DarkText size="15px">
            <Description htmlString={report?.description} />
          </DarkText>
        </FlexWrapper>
        <FlexWrapperReport
          cursor="default"
          direction="column"
          gap="10px"
          justify="start"
          align="start"
          width="40%"
          style={{
            backgroundColor: '#F3F6FC',
            borderRadius: '12px',
            padding: '16px'
          }}>
          <span style={{ fontSize: '18px', fontWeight: '600', fontFamily: 'Plus Jakarta Sans' }}>
            Done Points
          </span>
          {reportingDonePoints?.map((option, i) => (
            <FlexWrapper
              key={i}
              completed={(report?.checklists || [])?.includes(option)}
              gap="6px"
              align="flex-start"
              justify="flex-start"
              cursor="default"
              wrap="nowrap">
              <input
                type="checkbox"
                checked={(report?.checklists || [])?.includes(option)}
                style={{
                  width: '16px',
                  height: '16px',
                  accentColor: theme?.primaryColor,
                  cursor: 'default'
                }}
              />
              <span
                style={{
                  textAlign: 'start',
                  fontSize: '15px',
                  fontFamily: 'Plus Jakarta Sans'
                }}>
                {option}
              </span>
            </FlexWrapper>
          ))}
        </FlexWrapperReport>
      </ContentWrapper>
    </ExpandCollapseWrapper>
  );
};

const ContentWrapper = styled(FlexWrapper)`
  align-items: unset;
  flex-wrap: nowrap;
  background-color: #fff;
  border-radius: 12px;
  padding: 0 20px 20px;
  margin: 0;
  gap: 20px;
  cursor: default;
  width: 100%;
  @media (max-width: 968px) {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 20px;
    flex-wrap: wrap;
    justify-content: start;
  }
`;

ReportingCard.propTypes = {
  report: PropTypes.object.isRequired,
  handleGetList: PropTypes.func,
  empName: PropTypes.string
};
export default ReportingCard;

export const FlexWrapperReport = styled.div`
  width: ${(props) => props.width};
  display: flex;
  flex-wrap: ${(props) => props.wrap || 'wrap'};
  flex-direction: ${(props) => props.direction || 'row'};
  justify-content: ${(props) => props.justify || 'center'};
  align-items: ${(props) => props.align || 'center'};
  gap: ${(props) => props.gap || '10px'};
  cursor: ${(props) => props.cursor || 'auto'};
  margin: ${(props) => props.margin || '0px'};
  @media (max-width: 968px) {
    width: 100% !important;
    align-items: start;
    justify-content: start;
  }
`;
const DarkText = styled.p`
  width: 100%;
  text-align: start;
  color: #0e0e0e !important;
  font-size: ${({ size }) => size || '14px'};
  font-weight: ${({ weight }) => weight || '500'};
  margin: ${({ margin }) => margin || '0'};
  font-family: Plus Jakarta Sans;
`;
